import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { TimeLogUser } from "./UserManagement";

export const headerTemplate = (
  header: string,
  field: string,
  setSortFilter: any,
  extraClassName?: string
) => {
  return (
    <div
      className={`${
        extraClassName ?? ""
      } tw-flex tw-justify-between tw-w-full tw-items-center ${
        field !== "" && "tw-cursor-pointer"
      }`}
      onClick={() => {
        if (field !== "") {
          setSortFilter((prevSortFilter: any) => ({
            ...prevSortFilter,
            sortField: field,
            sortOrder: !prevSortFilter.sortOrder,
          }));
        }
      }}
    >
      <span className="tw-font-bold">{header}</span>
      {field !== "" && (
        <span className="tw-ml-4 tw-mr-0">
          <TableSortingSVG />
        </span>
      )}
    </div>
  );
};

export const departmentTemplate = (rowData: TimeLogUser) => {
  return (
    <div className="tw-flex tw-flex-wrap">
      {rowData.departments.map((departments: any, index: number) => {
        return (
          <span key={index} className={index % 3 !== 2 ? "tw-mr-0" : ""}>
            {departments.department}
            {index !== rowData.departments.length - 1 ? `,` : ""}&nbsp;
          </span>
        );
      })}
    </div>
  );
};
